<template>
  <div class="standalone-logo-tile" :style="{ width: size + 'px', height: size + 'px' }">
    <img v-if="src && !failed" :src="src" :alt="alt" referrerpolicy="no-referrer" @error="failed = true" />
    <span v-else class="standalone-logo-fallback" :style="{ fontSize: Math.round(size * 0.42) + 'px' }">
      {{ initial }}
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

/** White rounded-square brand tile — see frontend-style-guide.md "Logos vs avatars". */
export default defineComponent({
  name: "LogoTile",
  props: {
    src: { type: String as () => string | null, default: null },
    alt: { type: String, default: "" },
    size: { type: Number, default: 32 },
  },
  setup(props) {
    const failed = ref(false);
    watch(
      () => props.src,
      () => {
        failed.value = false;
      },
    );
    const initial = props.alt?.trim()?.[0]?.toUpperCase() || "?";
    return { failed, initial };
  },
});
</script>
